export const hideLoadingSpinner = () => {
  // Remove the full page loading spinner that the My Mortgage web app introduces
  const fullPageSpinner = document.getElementById('full-page-spinner');
  fullPageSpinner?.classList.add('full-page-spinner--hide');
};
